import {ignoreReset, ignoreUndo} from "./undo";
import {pasteCondition} from "./conditional_formats";
import {pasteDropdown} from "./dropdown";
import {pasteFilter} from "./filter";
import {pasteSpan} from "./spans";
import {pasteValidation} from "./validation";

let styledata, clipdata, origin, cutted, updateFilters, specialPaste, context;

export function init(view){
	view.attachEvent("onSheetRename", (name, newName)=> {
		if(context && context.page == name && context.view == view)
			context.page = newName;
	});

	view.attachEvent("onSheetRemove", (name)=> {
		if(context && context.page == name && context.view == view)
			context = null;
	});

	const clipboard = view.config.clipboard;
	const browserClipboard = navigator.clipboard;

	if(clipboard === false)
		return;

	webix.clipbuffer.init();
	const buffer = document.querySelector(".webix_clipbuffer");

	const keyC = 67; //keyboard 'c' code
	const keyX = 88; //keyboard 'x' code
	const grid = view.$$("cells");

	grid.attachEvent("onSelectChange", () => _sel_to_clip(view, buffer));

	grid.attachEvent("onKeyPress", (code, e) => {
		if((code === keyC || code === keyX) && (e.ctrlKey || e.metaKey) && grid.getSelectedId()){
			cutted = (code === keyX)*1;
			setClipboard(view, buffer);
		}
	});

	view.attachEvent("onCommand", action => {
		if(action.id.indexOf("paste") != -1){
			specialPaste = action.id.split("-")[1];

			if(browserClipboard && browserClipboard.readText){
				browserClipboard.readText()
					.then(text => {
						webix.clipbuffer.set(text);
						_clip_to_sel(view, grid, buffer.value);
					})
					.catch(()=> {
						_clip_to_sel(view, grid, clipdata);
					})
					.finally(()=> {
						specialPaste = null;
					});
			}
			else {
				_clip_to_sel(view, grid, clipdata);
				specialPaste = null;
			}
		}
		else if(action.id == "copy" || action.id == "cut"){
			cutted = (action.id == "cut")*1;
			setClipboard(view, buffer, browserClipboard, true);
		}
	});

	view.attachEvent("onUndo", (action, row, column, data) => {
		if (action == "paste"){
			const state = grid.getScrollState();
			const sel = grid.getSelectArea();
			// data loading resets undo history, and
			// we need to preserve it
			ignoreReset(()=>{
				view.$handleSelection = null;
				view.parse(data);

				grid.addSelectArea(sel.start, sel.end);
				grid.scrollTo(state.x, state.y);
			});
		}
	});

	if (!view.config.readonly) {
		grid.attachEvent("onPaste", text => {
			_clip_to_sel(view, grid, text);
		});
	}
}

function setClipboard(view, buffer, browserClipboard, menu){
	const grid = view.$$("cells");
	origin = grid.getSelectArea();
	
	styledata = _get_sel_style(view);
	context = { page: view.getActiveSheet(), view };

	if(menu && browserClipboard && browserClipboard.writeText)
		browserClipboard.writeText(buffer.value);

	clipdata = buffer.value;

	if(cutted && Object.keys(grid._ssFilters).length !== 0)
		updateFilters = allFiltersInZone(grid._ssFilters, view.config.columnCount);
}

function _sel_to_clip(view, buffer){
	if(view._loading_data) return;
	const grid = view.$$("cells");
	if(grid.getSelectedId())
		webix.delay(()=>{
			const data = [];

			const origin = grid.getSelectArea();
			for(let r = origin.start.row; r <= origin.end.row; r++){
				const row = [];
				for(let c = origin.start.column; c <= origin.end.column; c++)
					row.push(_updateDelimiter(view.getCellValue(r, c, false), view.config));
				data.push(row);
			}

			const clipdata = webix.csv.stringify(data, grid.config.delimiter);

			if (grid.getEditor()){
				buffer.value = clipdata;
			} else {
				buffer.focus();
				webix.clipbuffer.set(clipdata);
			}
			webix.UIManager.setFocus(grid);
		});
}

function _updateDelimiter(value, config) {
	const format = getClipboardNumberFormat(config);

	if(webix.rules.isNumber(value) && format)
		value = webix.Number.numToStr(format)(value);

	return value;
}

function _clip_to_sel(view, grid, text){
	if(!text)
		text = "";

	const leftTop = grid.getSelectArea();
	if (!leftTop) return;
	const start = leftTop.start;
	const end = leftTop.end;

	const fromSheet = text === clipdata;

	let data = fromSheet ? styledata : webix.csv.parse(text, grid.config.delimiter);
	if(!fromSheet)
		data = _changeDelimiter(data, view.config);

	const translate = { id:"move", column:0, row: 0, cut:cutted };
	const sameView = context && context.view == view;

	if(specialPaste || !fromSheet){
		cutted = 0;
		updateFilters = 0;
	}

	const oldData = view.serialize();

	ignoreUndo(()=>{
		const dataRowCount = data.length;
		const dataColCount = data[0].length;

		const colCount = end.column - start.column + 1;
		let rowCount = end.row - start.row + 1;

		_add_row_col(view, start, rowCount, data);

		if(fromSheet){
			translate.column = start.column - origin.start.column;
			translate.row = start.row - origin.start.row;

			if (updateFilters){
				const sel = grid.getSelectArea();
				view.removeFilters();
				grid.addSelectArea(sel.start, sel.end);
			}

			const mode = (!cutted && !updateFilters && (rowCount > dataRowCount || colCount > dataColCount)) ? 2 : 0;

			if(specialPaste != "conditions"){
				if (cutted == 1){
					if(sameView){
						view._mData.getCopyManager().move(
							view._mPage.cellID(start.row-1, start.column-1),
							view._mData.getStore().getMeta().$clipboard
						);
					}
					if(context && !context.view.$destructed)
						context.view.groupUndo(()=>{
							for (let row = origin.start.row; row <= origin.end.row; row++) {
								for (let column = origin.start.column; column <= origin.end.column; column++) {
									context.view.setCellValue(row, column, null, context.page);
									context.view.setStyle(row, column, null, context.page);
								}
							}
						});
				}
				else if(sameView){
					let handler;
					if(specialPaste)
						handler = (a, b) => {
							switch(specialPaste){
								case "formulas":
									return webix.extend(a, { value: b.formula || b.value }, true);
								case "styles":
									return webix.extend(a, {style: b.style, format: b.format }, true);
								case "values":
									return webix.extend(a, {value: b.value }, true);
								case "validation":
									return webix.extend(a, {validation: b.validation }, true);
							}
						};

					view._mData.getCopyManager().paste(
						view._mPage.cellID(start.row-1, start.column-1),
						view._mPage.cellID(
							Math.max(start.row + origin.end.row - origin.start.row, end.row)-1,
							Math.max(start.column + origin.end.column - origin.start.column, end.column)-1
						),
						view._mData.getStore().getMeta().$clipboard,
						mode,
						handler
					);
				}
			}

			if (mode == 2) {
				for(let r = 0, ri = 0; r < Math.max(rowCount, dataRowCount); r++, ri++){
					if(ri == data.length) ri = 0;
					for (let c = 0, ci = 0; c < Math.max(colCount, dataColCount); c++, ci++){
						if(ci == data[0].length) ci = 0;

						const subtrans = {
							id: "move",
							column: translate.column + Math.floor(c/dataColCount) * dataColCount,
							row: translate.row + Math.floor(r/dataRowCount) * dataRowCount,
							cut: cutted
						};

						_clipboardToTable(view, start.row + r, start.column + c, data[ri][ci], subtrans);
					}
				}
			} else {
				grid.mapCells(
					start.row,
					start.column,
					dataRowCount,
					null,
					function(value, row, col, row_ind, col_ind) {
						if (data[row_ind] && data[row_ind].length > col_ind) {
							const cdata = data[row_ind][col_ind];
							_clipboardToTable(view, row, col, cdata, translate);
						}
					},
					true
				);
			}
			if(cutted == 1){
				//cut and cleared
				cutted = 2;
				updateFilters = false;
			}
		}
		else 
			for (let r = 0, ri = 0; r < Math.max(rowCount, dataRowCount); r++, ri++) {
				if (ri == data.length) ri = 0;
				for (var c = 0, ci = 0; c < Math.max(colCount, dataColCount); c++, ci++) {
					if (ci == data[0].length) ci = 0;
					view.setCellValue(start.row + r, start.column + c, data[ri][ci]);
				}
			}
	}, view);

	view.callEvent("onAction", ["paste", {
		value: oldData,
		newValue: view.serialize()
	}]);
	view.callEvent("onCommand", [{id:"toolbar-update"}]);
	view.refresh();
}

function _clipboardToTable(view, row, col, cdata, translate){
	if (typeof cdata === "object"){
		const sameView = context && context.view == view;
		if(!(sameView && context.page == view.getActiveSheet())){
			if(!sameView && (!specialPaste || specialPaste == "values" || specialPaste == "formulas"))
				view.setCellValue(
					row,
					col,
					cdata.math && specialPaste != "values" ? view._mData.getStore().transposeMath(cdata.math, translate.row, translate.column) : cdata.text
				);

			if(cdata.style && cdata.style.props && (!specialPaste || specialPaste == "styles")){
				const style = view.addStyle(cdata.style.props);
				view.setStyle(row, col, style);
			}
		}

		const extra = cdata.extra;
		if(extra){
			if(extra.condition && (!specialPaste || specialPaste == "conditions"))
				pasteCondition(view, extra, row, col, cutted);
			if(extra.dropdown && !specialPaste)
				pasteDropdown(view, extra, row, col, cutted, translate);
			if(extra.filter && updateFilters)
				pasteFilter(view, extra, row, col, cutted, translate);
			if(extra.validation && (!specialPaste || specialPaste == "validation"))
				pasteValidation(view, extra, row, col, cutted, translate);
		}

		if(!specialPaste)
			pasteSpan(view, extra, row, col, cutted, translate);

		view.saveCell(row, col, view.getActiveSheet());
	}
}

function _get_sel_style(view){
	const data = [];

	const cm = view._mData.getCopyManager();
	cm.copy(
		view._mPage.cellID(origin.start.row-1, origin.start.column-1),
		view._mPage.cellID(origin.end.row-1, origin.end.column-1)
	);

	for(let r = origin.start.row; r <= origin.end.row; r++){
		const row = [];
		for(let c = origin.start.column; c <= origin.end.column; c++){
			let math = view.getCellValue(r, c);
			math = math && math[0] == "=" && math.length > 1 ? math : null;

			const obj = { text: view.getCellValue(r, c, false), math, style: view.getStyle(r, c) };

			const condition = view.conditions.get(r, c);
			const editor = view.getCellEditor(r, c);
			const filter = view.getCellFilter(r, c);
			const span = view._table.getSpan(r, c);
			const validation = view.validation.get(r, c);

			if (editor || filter || condition || span || validation){
				const extra = { row:r, col:c };
				if (condition) extra.condition = condition;
				if (editor) extra.dropdown = editor;
				if (filter) extra.filter = filter;
				if (span) extra.span = span;
				if(validation) extra.validation = validation;
				obj.extra = extra;
			}

			row.push(obj);
		}
		data.push(row);
	}

	return data;
}

function allFiltersInZone(extra, columnCount){
	var filters = Object.keys(extra);
	var startRow = Math.min.apply(null, filters);
	var endRow = Math.max.apply(null, filters);
	var startCol = columnCount;
	var endCol = 1;

	for (var i = startRow; i <= endRow; i++){
		if(extra[i]){
			var columns = Object.keys(extra[i]);
			startCol = Math.min(startCol, Math.min.apply(null, columns));
			endCol = Math.max(endCol, Math.max.apply(null, columns));
		}
	}

	if(origin.start.row <= startRow && origin.end.row >= endRow && origin.start.column <= startCol && origin.end.column >= endCol)
		return true;
	else
		return false;
}
//dynamically increase rows and columns according to pasted data size
function _add_row_col(view, start, rowCount, data){
	var maxCol = start.column + data[0].length - 1;
	let maxRow;

	if(rowCount > data.length){
		let extraSpanRows = 0;
		const lastRows = rowCount % data.length;
		for (let r = 0; r < lastRows; r++) {
			for(let c = 0; c < data[r].length; c++){
				if(data[r][c].extra && data[r][c].extra.span){
					const span = data[r][c].extra.span;
					if(span[0] == origin.start.row + r && span[1] == origin.start.column + c){
						const extra = r + span[3] - lastRows;
						if(extra > 0)
							extraSpanRows = Math.max(extra, extraSpanRows);
					}
				}
			}
		}
		maxRow = start.row + rowCount + extraSpanRows - 1;
	}
	else
		maxRow = start.row + data.length - 1;

	if(maxRow > view.config.rowCount || maxCol > view.config.columnCount){
		var action = { id:"add" };
		if (maxRow > view.config.rowCount) {
			action.group = "row";
			view.callEvent("onCommand", [
				action, 
				{ row: view.config.rowCount + 1 }, 
				{ row: maxRow }
			]);
		}
		if (maxCol > view.config.columnCount) {
			action.group = "column";
			view.callEvent("onCommand", [
				action, 
				{ column: view.config.columnCount + 1 },
				{ column: maxCol }
			]);
		}
	}
}

function _changeDelimiter(data, config){
	const format = getClipboardNumberFormat(config);

	if(format)
		for(let i = 0; i < data.length; i++)
			for(let k = 0; k < data[i].length; k++){
				const record = webix.Number.parse(data[i][k], format);
				if(webix.rules.isNumber(record))
					data[i][k] = record;
			}

	return data;
}

function getClipboardNumberFormat(config){
	let format = config.clipboardNumberFormat;

	if(!format && config.clipboardDecimalDelimiter) // backward compatibility
		format = {
			decimalDelimiter: config.clipboardDecimalDelimiter,
			decimalOptional: true
		};

	if(format)
		webix.extend(format, {
			minusSign: webix.i18n.minusSign,
			minusPosition: webix.i18n.minusPosition,
		});

	return format;
}